module.exports = __webpack_public_path__ + "img/about-4-INTmap.6602c781.png";